import { on } from 'delegated-events'

on('ajaxform:submit', 'html', (e) => {
  const form = e.detail.form
  const loginUrl = form.querySelector('[name="LoginURL"]')
  const redirectUrl = form.querySelector('[name="RedirectURL"]')

  if (loginUrl) {
    setTimeout(() => {
      window.location.href = loginUrl.value
    }, 3000)
  }

  if (redirectUrl) {
    window.location.href = redirectUrl.value
  }
})
